import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LogsTable from './LogsTable';
import FullPageLoader from 'components/common/FullPageLoader';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import { CheckinCheckoutAdjustmentModal } from 'components/appointment/checkinCheckoutAdjustment';
import CouldNotCover from 'components/appointment/CouldNotCover';
import DonotCover from 'components/appointment/DonotCover';
import CancelModal from 'components/appointment/CancelModal';
import { setActionAssign } from 'slices/actionButtonSlice';
import { fetchVendorAppointmentLogs, fetchVendorAppointmentView, vendorAppointmentDecline, vendorAppointmentAssign } from 'slices/vendor/appointmentSlice';
import SelectInterpreterModal from 'components/vendorAccess/SelectInterpreterModal';
import VendorDeclineModal from 'components/vendorAccess/VendorDeclineModal';
import ExtraMileage from 'components/appointment/ExtraMileage';
import ViewTable from 'views/appointment/view/ViewTable';

const AppointmentView = () => {
    
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);
    const user = useSelector((state) => state.user?.user);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [donotCover, setDonotCover] = React.useState(false);
    const [couldNotCover, setCouldNotCover] = React.useState(false);
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
    const [assignInterpreter, setAssignInterpreter] = React.useState(false);
    const [extraMileage, setExtraMileage] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(false);
    

    const callViewApi = async () => {
        const callBack = (success, message, data, status) => {
            setLoading(false);
            if (success) {
                setItem(data)
            } else if (status === 403) {
                toast.error('You are not authorized to view this appointment.', { className: 'errorToast' });
                navigate('/vendor/dashboard');
            } else {
                console.log(message)
            }
        }

        dispatch(fetchVendorAppointmentView(id, callBack))
    };

    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
            // setLogs()
        }
        dispatch(fetchVendorAppointmentLogs(id, callBack))
    }

    React.useEffect(() => {
        setLoading(true)
        callViewApi();
        // fetchLogs();

    }, [id]);
    const handleCancel = () => {
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };
    const handleDonotCover = () => {
        setDonotCover(true);
    };
    const handleCloseDonotCover = () => {
        setDonotCover(false);
    };
    const handleCouldNotCover = () => {
        setCouldNotCover(true);
    };
    const handleCloseCouldNotCover = () => {
        setCouldNotCover(false);
    };
    const handleOpenCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(true);
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleAssignInterpreter = () => {
        setAssignInterpreter(true);
    };
    const handleCloseAssignInterpreter = () => {
        setAssignInterpreter(false);
    };

    const handleExtraMileage = () => {
        setExtraMileage(true);
    };
    const handleCloseExtraMileage = () => {
        setExtraMileage(false);
    };

    const handleSubmit = (data, end_point, callBack) => {
        setLoading(true)
        const submitCallback = (success, message) => {
            callBack && callBack()
            if (success) {
                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseCheckinCheckoutModal();
                handleCloseAssignInterpreter();
                handleCloseExtraMileage();
                callViewApi();
                fetchLogs()
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false)
            }
            else {
                toast.error(message,
                    { className: "errorToast", }
                );
                setLoading(false)
            }
        }
        if (end_point === 'assign') {
            dispatch(vendorAppointmentAssign(id, data, submitCallback))
        } else {
            dispatch(setActionAssign(id, data, end_point, submitCallback))
        }
    }
    const handleDecline = () => {
        setDeclineModal(true);
    };

    const handleDeclineSubmit = (data) => {
        setLoading(true);
        setDeclineModal(false);
        const callback = (success, message) => {
            setLoading(false);
            if (success) {
                toast.success(message || 'Appointment declined.', { className: 'successToast' });
                navigate('/vendor/dashboard');
            } else {
                toast.error(message || 'Failed to decline appointment.', { className: 'errorToast' });
            }
        };
        dispatch(vendorAppointmentDecline(id, data, callback));
    };

    const mileageCheck = (val) => {
        return item?.appointment_details?.[val];
    }
    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader />}
            <div className="card_table view_table_custom">
                {(mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == null) ?
                    <div className='softAlert waiting'>
                        <h3>We've received your request for extra mileage — awaiting admin approval.</h3>
                    </div>
                    :
                    (mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == 1) ?
                        <div className='softAlert approved'>
                            <h3>The extra mileage request for this appointment have been approved.</h3>
                        </div>
                        : (mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == 0) ?
                            <div className='softAlert rejected'>
                                <h3>The extra mileage request for this appointment have been rejected.</h3>
                            </div>
                            :
                            ''
                }
                <div className="row_main_head">
                    <div className={`d-flex gap-3`}>
                    <h2 className={`main_heading d-flex`}>View Appointment # {item?.appid}</h2>
                    {user?.role === "vendor" && item?.reference_no && (
                    <h2 className={`main_heading`}>(Reference No: {item?.reference_no})</h2>
                    )}
                    </div>
                    <div className='text-transform-capitalize main_heading' >
                        Status : {item?.status}
                    </div>
                </div>

                <div className='row-primary flex-wrap'>
                    {(item?.status === 'cancelled' || item?.status === 'declined') ? (
                        null
                    ) : item?.status !== 'completed' ? (
                        <>
                            <SubmitButton buttonType="button" className={'green'} btnText={item?.interpreter_id ? "Reassign" : "Assign"} handleSubmit={handleAssignInterpreter} />
                            {item?.status !== 'pending' && (
                                <SubmitButton buttonType="button" className="Cancle_button"
                                    btnText="Checkin / checkout"
                                    data-bs-toggle="modal"
                                    data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                            )}
                            <SubmitButton buttonType="button" className="delete_button tomatoRed" btnText="Decline" handleSubmit={handleDecline} />
                        </>
                    ) : (
                        <SubmitButton buttonType="button" className="Cancle_button"
                            btnText="Checkin / checkout"
                            data-bs-toggle="modal"
                            data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                    )}
                </div>

                <ViewTable item={item} />
            </div>

            <SelectInterpreterModal
                isVendorForm={true}
                isOpen={assignInterpreter}
                onClose={handleCloseAssignInterpreter}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />

            <CancelModal
                isOpen={cancelModal}
                onClose={handleCloseCancel}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
                title="Cancel Appointment"
                btnText="Cancel"
                endpoint="admin-cancel"
            />

            <ExtraMileage
                isOpen={extraMileage}
                onClose={handleCloseExtraMileage}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                appointmentId={id}
                onSubmit={handleSubmit}
                item={item}
                loader={loading}
            />
            <VendorDeclineModal
                isOpen={declineModal}
                onClose={() => setDeclineModal(false)}
                onConfirm={handleDeclineSubmit}
                appointmentId={id}
                loader={loading}
            />
        </div>
    )
}





export default AppointmentView